module.exports = __webpack_public_path__ + "static/xlc-logo-41ee0dcc02b22cbb3666cc0256239b84.png";